module.exports = __webpack_public_path__ + "img/Pot3.b290a5c0.svg";